import React from 'react';
import Header from '../components/header/Header';
import FloatingButton from '../components/bottomtotop/FloatingButton';
import { FaAndroid, FaApple, FaBrain, FaCode, FaDollarSign, FaGlobe, FaHeadset, FaListUl, FaTags, FaUsers } from 'react-icons/fa6';
import { FaGlobeAmericas, FaHandPaper, FaPlayCircle, FaPlusCircle, FaShieldAlt, FaSyncAlt, FaTools, FaUserFriends } from 'react-icons/fa';
import Footer from '../components/footer/Footer';

const WhySelzor = () => {

  const crmfeatures = [
      {
        title: 'Instant Setup',
        description: 'With Selzor’s smooth & user-friendly setup wizard, you can get started in minutes. No more waiting for weeks or months to develop your own custom ordering app.',
        icon: <FaBrain />,
      },
      
  {
    title: 'No Commitments',
    description: 'Enjoy complete freedom with Selzor—no long-term contracts or binding commitments. Scale, pause, or cancel anytime, giving you the flexibility to adapt as your business needs change.',
    icon: <FaHandPaper />,
  },
  {
    title: 'Web App',
    description: 'Access Selzor instantly from any web browser on desktop or mobile devices. No installation needed—just log in and manage your orders seamlessly from anywhere.',
    icon: <FaGlobe />,
  },
  {
    title: 'Android App',
    description: 'Our dedicated Android app allows you to handle orders, track inventory, and manage customers on the go, with a smooth, user-friendly interface designed for busy professionals.',
    icon: <FaAndroid />,
  },
  
  {
    title: '50+ Features',
    description: 'Selzor offers over 50 built-in features tailored for B2B ordering—from product catalogue to order tracking—giving you all the tools you need in one platform.',
    icon: <FaListUl />,
  },

  
  {
    title: 'Try Before You Buy',
    description: 'Experience the full power of Selzor risk-free with a trial period. Explore all features and benefits before making a purchase decision.',
    icon: <FaPlayCircle />,
  },
  {
    title: 'One Price for All',
    description: 'Enjoy transparent and straightforward pricing—one affordable fee covers access to all features, apps, and support without hidden charges.',
    icon: <FaTags />,
  },
  {
    title: 'Trusted Worldwide',
    description: 'Join thousands of businesses around the world who trust Selzor to manage their B2B ordering efficiently and reliably every day.',
    icon: <FaGlobeAmericas />,
  },
  {
    title: 'Zero Maintenance',
    description: 'Forget about software updates or server upkeep. Selzor’s expert team handles all maintenance so you can focus on running your business.',
    icon: <FaTools />,
  },
  {
    title: '24x7 Support',
    description: 'Get help whenever you need it with our dedicated support team available 24/7 to assist you with any issues or questions.',
    icon: <FaHeadset />,
  },
  {
    title: 'Security Enhancement',
    description: 'Your data is protected with automatic backups and advanced security protocols, ensuring business continuity and peace of mind.',
    icon: <FaShieldAlt />,
  },
  {
    title: 'Experienced Team',
    description: 'Benefit from the expertise of our skilled team, who understand B2B ordering complexities and are dedicated to supporting your success.',
    icon: <FaUsers />,
  },
  {
    title: 'User Friendly UI',
    description: 'Selzor is built with a clean, intuitive interface that makes it easy for your team to learn and use, reducing training time.',
    icon: <FaUserFriends />,
  },
  {
    title: 'API Integration',
    description: 'Easily integrate Selzor with your existing systems via robust APIs, enabling seamless data exchange and workflow automation.',
    icon: <FaCode />,
  },
    ];

  return (
    <div>
        <Header />

         <section className="mx-auto max-w-7xl py-12">
          <div className="container mx-auto px-4">
            <div className="flex flex-col gap-6 sm:gap-8">
              <div className='text-start'>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-700 mb-2 sm:mb-10">
                Selzor is on a mission to redefine the B2B ordering experience for businesses around the globe. Join us and go digital today.
                </h2>
                <p className="text-gray-600 text-base sm:text-lg mb-2 sm:mb:3">
                 Selzor is a seamless B2B Ordering Platform for web & mobile. After thousands of man hours in concept design, UI/UX design, coding/programming for web & mobile platforms, backend server setup & rigorous testing, all the hard work has already been done by our team & today Selzor is a ready solution that is being accepted by users worldwide. It is convenient for you as a business, to start using the tried & tested Selzor App rather than investing heavy amounts on the development of your own custom app from your local developer. By choosing Selzor, you know exactly what you are going to get & at what price. New feature additions are being done on a continuous basis, to meet the ongoing demand & feature requests made by our esteemed customers & you, as a Selzor User, get these features free of cost.
                </p>
                <p className="text-gray-600 text-base sm:text-lg mb-2 sm:mb:3">
                We at Selzor are on a mission to transform the entire B2B Ordering Experience for Businesses across the globe.
                </p>
              </div>
            
              <div className="grid grid-cols-12 gap-3">
                {crmfeatures.map((feature, index) => (
                  <div key={index} className="col-span-12 sm:col-span-6 lg:col-span-4">
                    <div className="animate-y rounded-3xl sm:rounded-[32px] md:rounded-[40px] bg-[#dbf4f1] overflow-hidden h-full">
                      <div className="relative p-6 sm:p-8 md:p-10 flex flex-col items-start h-full gap-8 sm:gap-8 md:gap-8">
                        <div className='bg-[rgba(7,_166,_152,_0.6)] filter blur-[75px] w-[151px] h-[151px] absolute -top-[80px] -right-[100px]'></div>
                        <span className='text-5xl text-[#1a9588] bg-white rounded-full p-5'>{feature.icon}</span>
                      
                        <div className="flex flex-col text-start gap-2 sm:gap-3">
                          <h4 className="text-2xl">{feature.title}</h4>
                          <p className="text-lg text-gray-700">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <FloatingButton />
        <Footer />
    </div>
  )
}

export default WhySelzor